import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'

const NavigationButton: React.FC<{
  text: string
  icon: IconProp
  href?: string
}> = ({ text, icon, href }) => {
  const isInternalLink = !!href && href.startsWith('/')

  const content = (
    <>
      <div className='mr-4 flex h-[34px] w-[34px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
        <FontAwesomeIcon
          icon={icon}
          className='text-icon-brand'
        />
      </div>

      <p className='text-text-primary'>{text}</p>
    </>
  )

  if (isInternalLink) {
    return (
      <Link
        to={href}
        className='mb-4 flex h-[62px] w-full items-center rounded-md border border-border-subtle bg-surface-card px-4 text-left text-text-primary'
      >
        {content}
      </Link>
    )
  }

  return (
    <a
      href={href}
      className='mb-4 flex h-[62px] w-full items-center rounded-md border border-border-subtle bg-surface-card px-4 text-left text-text-primary'
    >
      {content}
    </a>
  )
}

export default NavigationButton
